import { gql } from '@apollo/client'

export const familyDataMutation = gql`
  mutation familyData(
    $civilStatus: String
    $civilStatusSince: String
    $partner: InputFamilyMember
    $children: [InputFamilyMember]
  ) {
    familyData(
      familyData: {
        civilStatus: $civilStatus
        civilStatusSince: $civilStatusSince
        partner: $partner
        children: $children
      }
    ) {
      success
    }
  }
`
